<mwe-basic-card [hasBackground]="true" class="d-block mb-4">
  @if (isTitleVisible()) {
    <mwe-basic-card-title [cardTitle]="'invoiceInformation.invoiceHow.title'" iconClass="fas fa-wallet" headingNodeType="h2" />
  }

  @if (isSepaOrZahlscheinSliderVisible()) {
    @if (showPaymentSelectForm()) {
      <mwe-form
        #paymentForm
        [formModel]="paymentSelectionForm()"
        (formIsValid)="onPaymentFormChange($event)"
        (formIsInvalid)="onPaymentFormChange($event)"
      />
    }
    @if (!showPaymentSelectForm()) {
      <mwe-form [formModel]="readonlyPaymentSelectionForm()" />
    }
  }

  @if (invoiceSEPA()) {
    <mwe-iban-form
      [config]="ibanConfig()"
      (formSubmitted)="ibanFormSubmitted($event)"
      (validationErrors)="ibanFormError($event)"
      [productCategories]="productCategories()"
    />
  }
</mwe-basic-card>

@if (isInternationalAddressInputVisible()) {
  <mwe-basic-card
    [hasBackground]="true"
    [cardTitle]="newInvoiceAddressTitle()"
    headingNodeType="h2"
    iconClass="fas fa-home"
    class="d-block mb-4"
  >
    <div class="pb-2" data-test="invoice-information-international-address-selection">
      <mwe-international-address-input
        [initialOlavEntry]="invoiceInfoConfig()?.initialAddressData?.olavEntry"
        [initialDataForManualForm]="invoiceInfoConfig()?.initialAddressData?.address"
        (selectionFinishedEvent)="checkAddress()"
      />
    </div>
  </mwe-basic-card>
}

@if (isERechnungVisible()) {
  <mwe-basic-card
    [hasBackground]="true"
    [cardTitle]="'invoiceInformation.erechnung.title'"
    headingNodeType="h2"
    iconClass="fas fa-envelope-open-text"
    class="d-block mb-4"
  >
    <div class="row pb-3">
      @if (showInvoiceSelectForm()) {
        <div>
          <mwe-form
            #invoiceForm
            [formModel]="invoiceSelectionForm()"
            (formIsValid)="onInvoiceFormChange($event)"
            (formIsInvalid)="onInvoiceFormChange($event)"
          />
        </div>
      }

      @if (!showInvoiceSelectForm()) {
        <mwe-form [formModel]="readonlyInvoiceSelectionForm()" />
      }

      @if (erechnungEnabled()) {
        <div data-test="invoice-information-eBilling-text">
          <mwe-form
            #emailForm
            [formModel]="emailAddressForm()"
            (formSubmitted)="onEmailFormChange($event, emailForm.isValid())"
            (formIsValid)="onEmailFormChange($event, true)"
            (formIsInvalid)="onEmailFormChange($event, false)"
          />
        </div>
        @if (showErechnungEmailInfobox()) {
          <mwe-infobox
            type="neutral"
            messageKey="invoiceInformation.erechnung.internetEmailInfo"
            class="d-block mb-3"
            data-test="invoice-information-internet-email-infobox"
          />
        }
      }

      @if (!erechnungEnabled() && address()) {
        <div data-test="invoice-information-eBilling-text">
          <mwe-form #emailForm [formModel]="readonlyAddressForm()" />
        </div>
      }
    </div>

    @if (showInvoiceEmailInfo()) {
      <mwe-infobox
        [messageKey]="invoiceInfoConfig()?.customerDataChangeEmailMsgKey"
        [textParams]="{ email: overrideEmailAddress() ?? erechnungData()?.rechnungEmail, address: address() }"
        class="d-block mb-3"
      />
    }

    @if (showInvoiceAddressChangeWarning()) {
      <mwe-infobox
        type="warning"
        [messageKey]="'invoiceInformation.erechnung.address-change-info'"
        [textParams]="addressChangeWarningPlaceholders()"
      />
    }
  </mwe-basic-card>
}
